module.exports = __webpack_public_path__ + "static/media/Drivenfi_BlackPink.4916dfbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/OptIn/logos/Drivenfi_BlackPink.png
// module id = 876
// module chunks = 0